import { Dispatch, SetStateAction, useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { usePageView } from 'src/analytics';
import { FOOTER_HEIGHT, HEADER_HEIGHT, MOBILE_MAX_WIDTH } from 'src/assets/static/constants';
import AppMessageListener from 'src/components/AppMessageListener';
import { LoadingScreen } from 'src/components/loading-screen';
import ScrollToTop from 'src/components/scroll-to-top';
import { useStores } from 'src/models';

import { Footer } from '../footer';
import { Header } from '../header';
import { HeaderProps } from '../header/Header';

// ----------------------------------------------------------------------

export interface LayoutProps {
  setHeaderProps: Dispatch<SetStateAction<HeaderProps>>;
}

interface MobileLayoutProps {
  needHeader?: boolean;
  needFooter?: boolean;
}

function MobileLayout({ needHeader = true, needFooter = true }: MobileLayoutProps) {
  const { authStore } = useStores();
  usePageView();

  const [headerProps, setHeaderProps] = useState<HeaderProps>({});

  return (
    <Container>
      {needHeader && <Header {...headerProps} />}
      <MainContainer needFooter={needFooter}>
        <Outlet context={{ setHeaderProps } as LayoutProps} />
      </MainContainer>
      {authStore?.user && needFooter && <Footer />}
      <ScrollToTop />
      <LoadingScreen />
      <AppMessageListener />
    </Container>
  );
}

const Container = styled('div')({
  width: '100%',
  height: '100vh',
  margin: 'auto',
  maxWidth: MOBILE_MAX_WIDTH,
});

const MainContainer = styled('main', {
  shouldForwardProp: (prop) => prop !== 'needFooter',
})<{ needFooter?: boolean }>(({ needFooter = true }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  paddingTop: HEADER_HEIGHT,
  paddingBottom: needFooter ? FOOTER_HEIGHT : 0,
}));

export default observer(MobileLayout);
